export const version = "4.2.8"; export const name = "@featbit/js-client-sdk";
